import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody, CardTitle, Modal, Form } from "reactstrap";
import avatar from "../../assets/images/users/AdminImg.png";
import configure from "configure";

const ViewNotes = ({ customer_notes }) => {
  const [viewFollowUp, setViewFollowUp] = useState(false);

  const [notes, setNotes] = useState([]);
  const [assign, setAssigned] = useState("");

  return (
    <React.Fragment>
      <div className="mb-3">
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-3 text-dark">Notes</CardTitle>

                <div>
                  {customer_notes?.length != 0 ? (
                    <ul className="verti-timeline list-unstyled notes-box">
                      {customer_notes?.map((notes) => (
                        <li
                          key={notes.id}
                          className="event-list position-relative"
                        >
                          <div className="event-timeline-dot">
                            <img
                              src={
                                notes?.userDetails?.avatar
                                  ? `${configure.marsimg}/${notes?.userDetails?.avatar}`
                                  : avatar
                              }
                              className="userImg me-3"
                              alt="User"
                            />
                          </div>
                          <div className="d-flex">
                            <div className="note flex-grow-1 ms-4 py-2 rounded ps-4">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <p className="text-muted mb-4">
                                    <h6 className="d-inline me-2">
                                      By {notes.userDetails?.name}
                                    </h6>
                                    {notes.created_at}{" "}
                                    <span className="pl-15">
                                      Got in touch with this Customer at{" "}
                                      {notes?.updated_at}
                                    </span>
                                  </p>
                                  <i className="bi bi-triangle-fill note-icon"></i>
                                </div>
                              </div>
                              <div
                                className="Features"
                                dangerouslySetInnerHTML={{
                                  __html: notes.description,
                                }}
                              />
                              <div>
                                {notes?.link && (
                                  <div>
                                    Attachment:{" "}
                                    <a
                                      target="_blank"
                                      rel="noreferrer"
                                      className="activity-log-btn text-info"
                                      href={notes.link}
                                    // onClick={()=> setViewFollowUp(true)}
                                    >
                                      <i className="fas fa-eye pe-1"></i>View
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                  {customer_notes?.length == 0 ? (
                    <p>No Notes has been Added Yet</p>
                  ) : null}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* View Follow Up Modal */}
      <Modal
        isOpen={viewFollowUp}
        size="sm"
        className="bd-custom-md-3"
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">View Follow Up</h5>
          <button
            type="button"
            onClick={() => {
              setViewFollowUp(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form className="row bd-span-input">
            <>
              <div className="mb-3 col-12">
                <label htmlFor="formrow-firstname-Input">Date</label>
                <div className="input-span">{notes?.created_at || "-"}</div>
              </div>
              <div className="mb-3 col-12">
                <label htmlFor="">Purpose</label>
                <div className="input-span">{notes?.description || "-"}</div>
              </div>
              <div className="mb-3 col-12">
                <label htmlFor="">Assigned</label>
                <div className="input-span">{notes?.added_by || "-"}</div>
              </div>
            </>
          </Form>
        </div>
      </Modal>
      {/* -------------- */}
    </React.Fragment>
  );
};

export default ViewNotes;
